import { api } from '@services';

const deleteTagCategory = async (id: string): Promise<void> => {
  await api.delete<void>(`/tagsCategory/${id}`);
};

export { deleteTagCategory };
